define((require) => {
    "use strict";

    var ExperienceViewer    = require("shared/ui/viewer/ExperienceViewer"),
        Size                = require("shared/util/Size"),
        PreviewSceneViewer  = require("ui/editor/PreviewSceneViewer"),
        _                   = require("underscore");

    /**
     * A <tt>ExperienceViewer</tt> used specifically for editor preview. Supporting zooming.
     *
     * @class PreviewExperienceViewer
     *
     * @see  PreviewSceneViewer
     */
    return ExperienceViewer.extend({
        initialize({zoomModel}) {
            // Setup the 'containerSizeProvider' to compensate for potential zooming.
            // See ExperienceViewer#responsiveViewerControllerOptions and ResponsiveViewerController#containerSizeProvider.
            this.responsiveViewerControllerOptions = {
                containerSizeProvider: function($container) {
                    var scale = zoomModel.get("scale");
                    return Size.from($container.width() * scale, $container.height() * scale);
                }
            };

            this.__super();

            this._zoomModel = zoomModel;
            // Minor hack to handle viewport size changes once the zoom scale changes...
            this.listenTo(zoomModel, "change:scale", this._scaleChangedHandler);
        },

        _scaleChangedHandler() {
            this._responsiveViewerController.updateIfValid();
            this._visibilityChangeHandler();
        },

        /**
         * @override
         */
        _newSceneViewer: function(options) {
            // Create a PreviewSceneViewer and pass on the zoom model...
            return new PreviewSceneViewer(_.extend(options, {
                zoomModel: this._zoomModel
            }));
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/PreviewExperienceViewer.js